import { EventEmitter } from 'events';

export const guideEmitter = new EventEmitter();